export default __webpack_public_path__ + "locales/ru/SalesDepartmentRequestDialog.json?hash=4bc352de0d42342b6ff8b949fc976275";